import { render, staticRenderFns } from "./idxGame04.vue?vue&type=template&id=3146cf42&"
import script from "./idxGame04.vue?vue&type=script&lang=js&"
export * from "./idxGame04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports